import { escapeZplField } from "./escape";

export type ZplPlaceholders = Record<string, string | number | undefined | null>;

/**
 * Extract `{{name}}` placeholder names from a template string, in first-seen order.
 */
export function extractPlaceholders(template: string): string[] {
  const seen = new Set<string>();
  const out: string[] = [];
  const re = /\{\{\s*([a-zA-Z0-9_]+)\s*\}\}/g;
  let match: RegExpExecArray | null;
  while ((match = re.exec(template)) !== null) {
    const name = match[1];
    if (!seen.has(name)) {
      seen.add(name);
      out.push(name);
    }
  }
  return out;
}

/**
 * Concatenate individual ZPL jobs into a single stream suitable for one raw print call.
 */
export function concatZpl(jobs: string[]): string {
  return jobs.filter((s) => s && s.trim().length > 0).join("\n");
}

export { escapeZplField };
